import { ElNotification } from 'element-plus';

export function useToast() {
  /** 呼叫toast */
  const openToast = (
    type: 'success' | 'warning' | 'info' | 'error',
    message: string,
    customClass?: string
  ) => {
    ElNotification({
      title: '系統異常，煩請通知技術人員',
      message: message,
      type: type,
      customClass: customClass,
      duration: 8000
    });
  };

  return {
    openToast
  };
}
